import { EventGuardConfig } from './eventGuard';
import roundEstimation from '../../../domain/estimations/roundEstimation';
import EstimationsDraftSaveRequested from '../../estimations/events/EstimationsDraftSaveRequested';
import EstimationChangeRequested from '../../estimations/events/EstimationChangeRequested';
import validateSavingDraft from '../../../domain/estimations/validateSavingEstimationDraft';
import OrderChangeRequested from '../../order/events/OrderChangeRequested';
import OrderDraftSaveRequested from '../../order/events/OrderDraftSaveRequested';
import validateSavingOrderDraft from '../../../domain/estimations/validateSavingOrderDraft';
import checkOrderValue from '../../../domain/orders/validators/checkOrderValue';
import { validatorsConfig } from '../../../domain/orders/validators/config';
import EstimationPlaceRequested from '../../estimations/events/EstimationPlaceRequested';
import validatePlaceEstimation from '../../../domain/estimations/validatePlaceEstimation';

const eventGuardConfig: EventGuardConfig[] = [
    {
        type: EstimationChangeRequested.type,
        validate: roundEstimation
    },
    {
        type: EstimationsDraftSaveRequested.type,
        validate: validateSavingDraft
    },
    {
        type: EstimationPlaceRequested.type,
        validate: validatePlaceEstimation
    },
    {
        type: OrderChangeRequested.type,
        validate: checkOrderValue(validatorsConfig)
    },
    {
        type: OrderDraftSaveRequested.type,
        validate: validateSavingOrderDraft
    }
];
export default eventGuardConfig;



// WEBPACK FOOTER //
// ./src/application/core/middleware/eventGuardConfig.ts